import * as React from 'react';
import { FaFacebookF, FaApple } from 'react-icons/fa';
// eslint-disable-next-line import/extensions
import { FacebookProvider } from 'react-facebook/dist/cjs/index.js';
import { isReactNativeWebView, useReactNativeWebView } from '../../../utils/isReactNativeWebView';
import {
  redirectGoogleLogin,
  redirectFacebookLogin,
  redirectMicrosoftLogin,
  redirectAppleLogin,
} from '../../../utils/providerLogin';
import { GoogleSignInButton } from '../GoogleSignInButton';
import { FacebookSignInButton } from '../FacebookSignInButton';
import { GoogleGSvg } from '../GoogleSignInButton/GoogleGSvg';
import { BtnIcon, BtnPrefix, SocialGroup, BtnBrand, BtnContent, SocialBtn } from './styles';

function MicrosoftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}

const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '';
const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID || '';

function FacebookLoginButton(props) {
  return <FacebookSignInButton {...props} />;
}

export function SocialIconButtons({
  onFacebookCompleted,
  onMicrosoftCompleted,
  onAppleCompleted,
  prefix = 'Entrar com',
  providers = ['google', 'facebook', 'microsoft', 'apple'],
  googleMode = 'gis',
}) {
  const inWebView = useReactNativeWebView();
  const useGoogleRedirect = inWebView || googleMode === 'redirect';

  const handleMicrosoftClick = () => {
    if (!MICROSOFT_CLIENT_ID) {
      onMicrosoftCompleted?.({ error: 'Microsoft login not configured' });
      return;
    }
    redirectMicrosoftLogin();
  };

  const handleAppleClick = () => {
    if (!APPLE_CLIENT_ID) {
      onAppleCompleted?.({ error: 'Apple login not configured' });
      return;
    }
    redirectAppleLogin();
  };

  const handleGoogleClick = () => {
    if (useGoogleRedirect) {
      redirectGoogleLogin();
    }
  };

  const handleFacebookClick = () => {
    if (inWebView) {
      redirectFacebookLogin();
    }
  };

  const has = (p) => providers.includes(p);

  return (
    <SocialGroup>
      {/* Google */}
      {has('google') &&
        (useGoogleRedirect ? (
          <SocialBtn type="button" onClick={handleGoogleClick}>
            <BtnContent>
              <BtnPrefix>{prefix}</BtnPrefix>
              <BtnBrand color="#EA4335">Google</BtnBrand>
            </BtnContent>
            <BtnIcon>
              <GoogleGSvg />
            </BtnIcon>
          </SocialBtn>
        ) : (
          <GoogleSignInButton prefix={prefix} />
        ))}

      {/* Facebook */}
      {has('facebook') &&
        (inWebView ? (
          <SocialBtn type="button" onClick={handleFacebookClick}>
            <BtnContent>
              <BtnPrefix>{prefix}</BtnPrefix>
              <BtnBrand color="#1877f2">Facebook</BtnBrand>
            </BtnContent>
            <BtnIcon>
              <FaFacebookF color="#1877f2" size={20} />
            </BtnIcon>
          </SocialBtn>
        ) : (
          <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_ID}>
            <FacebookLoginButton onFacebookCompleted={onFacebookCompleted} prefix={prefix} />
          </FacebookProvider>
        ))}

      {/* Microsoft */}
      {has('microsoft') && (
        <SocialBtn type="button" onClick={handleMicrosoftClick}>
          <BtnContent>
            <BtnPrefix>{prefix}</BtnPrefix>
            <BtnBrand color="#737373">Microsoft</BtnBrand>
          </BtnContent>
          <BtnIcon>
            <MicrosoftIcon />
          </BtnIcon>
        </SocialBtn>
      )}

      {/* Apple */}
      {has('apple') && (
        <SocialBtn type="button" onClick={handleAppleClick}>
          <BtnContent>
            <BtnPrefix>{prefix}</BtnPrefix>
            <BtnBrand color="#1c1c1e">Apple</BtnBrand>
          </BtnContent>
          <BtnIcon>
            <FaApple size={20} color="#1c1c1e" />
          </BtnIcon>
        </SocialBtn>
      )}
    </SocialGroup>
  );
}
